// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电路（二）",
      "tec": "李媛媛",
      "week": "11-14周",
      "add": "教学楼A座218电力"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "马睿",
      "week": "1-8,11-14周",
      "add": "教学楼A座421机械"
    },
    0,
    {
      "sub": "就业创业指导",
      "tec": "杨乘一",
      "week": "1-5周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "1-4周",
      "add": "教学楼C座306教务"
    }
  ],
  "2": [
    {
      "sub": "大学物理（下)",
      "tec": "潘云",
      "week": "1-8,11-16周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "电路（二）",
      "tec": "李媛媛",
      "week": "1-8周",
      "add": "教学楼B座124自控"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "25自机1-2",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-3",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-4",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-2",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-1",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-3",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "25自机1-5",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      }
    ],
    0,
    0
  ],
  "3": [
    {
      "sub": "马克思主义基本原理",
      "tec": "马睿",
      "week": "1-8,11-14周",
      "add": "教学楼A座421机械"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "王琪",
      "week": "1-8,11-18周",
      "add": "教学楼C座309教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电磁场与电磁波",
      "tec": "高明亮",
      "week": "1-8,11-18周",
      "add": "教学楼B座221自控"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "傅瑶",
      "week": "1-8,11-18周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "大学物理（下)",
      "tec": "潘云",
      "week": "1-8,11-16周",
      "add": "教学楼C座308教务"
    },
    0,
    0
  ],
  "5": [
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25自机2-3",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "25自机2-1",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25自机2-2",
        "tec": "丁璐瑶",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25自机2-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25自机1-5",
        "tec": "张琳琳",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "25自机1-2",
        "tec": "马丹",
        "week": "1-14周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "25自机1-4",
        "tec": "杨欣瑶",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "25自机1-3",
        "tec": "边克攀",
        "week": "1-14周",
        "add": "教学楼B座119自控"
      }
    ],
    [
      {
        "sub": "体育（三）",
        "tec": "李灏",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "男乒",
        "tec": "张慧",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "健美操",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "搏击",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "男篮",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "男网",
        "tec": "郝策",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "男网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "足球",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "男篮",
        "tec": "李莉",
        "week": "1-18周",
        "add": "男羽"
      },
      {
        "sub": "女篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "男羽"
      }
    ],
    {
      "sub": "概率论与数理统计",
      "tec": "王琪",
      "week": "1-8,11-18单周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "电路（二）",
      "tec": "李媛媛",
      "week": "1-8,11-14周",
      "add": "教学楼C座114教务"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
